// Libraries
import React, { memo } from 'react';
import PropTypes from 'prop-types';

// Enums
import { BAR_VERTICAL, BAR_HORIZONTAL, PIE } from 'common/enums/chartTypes';

// Components
import PieReportChart from 'admin/engagement/reporting/components/SingleSelectQuestionReport/PieReportChart';
import HorizontalBarReportChart from 'admin/engagement/reporting/components/NumericQuestionReport/HorizontalBarReportChart';
import VerticalBarReportChart from 'admin/engagement/reporting/components/NumericQuestionReport/VerticalBarReportChart';

const ReportChart = ({ data, compareInputs, chartType, chartRef }) => {
  switch (chartType) {
    case PIE:
      return <PieReportChart data={data} compareInputs={compareInputs} chartRef={chartRef} />;
    case BAR_HORIZONTAL:
      return (
        <HorizontalBarReportChart data={data} compareInputs={compareInputs} chartRef={chartRef} />
      );
    case BAR_VERTICAL:
    default:
      return (
        <VerticalBarReportChart data={data} compareInputs={compareInputs} chartRef={chartRef} />
      );
  }
};

ReportChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      percentage: PropTypes.number,
      top: PropTypes.bool,
    })
  ).isRequired,
  compareInputs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label_translations: PropTypes.objectOf(PropTypes.string),
    })
  ),
  chartType: PropTypes.oneOf([BAR_VERTICAL, BAR_HORIZONTAL, PIE]),
  chartRef: PropTypes.shape({
    current: PropTypes.elementType,
  }).isRequired,
};

ReportChart.defaultProps = {
  chartType: null,
  compareInputs: null,
};

export default memo(ReportChart);
